import { faBan, faMinus, faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cva, type VariantProps } from "class-variance-authority";
import { type MouseEventHandler } from "react";

import { cn } from "~/lib/utils";

export const quantityInputControlStyles = cva(
  "flex items-center justify-center text-center",
  {
    variants: {
      variant: {
        primary:
          "w-full rounded-full bg-kiosk-actions-sheet-primary-background px-3 text-2xl font-semibold text-kiosk-actions-sheet-primary-text opacity-95 shadow-md backdrop-blur-sm",
        secondary: "rounded-lg bg-kiosk-background-secondary text-3xl"
      },
      size: {
        md: "h-16 w-44",
        lg: "h-24 w-48",
        sm: "h-12 w-36"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "md"
    }
  }
);

const quantityInputControlButtonStyles = cva(
  "aspect-square h-16 bg-transparent",
  {
    variants: {
      variant: {
        primary: "rounded-full",
        secondary: "rounded-lg"
      },
      disabled: {
        true: "cursor-not-allowed opacity-50"
      }
    }
  }
);

type QuantityInputControlProps = VariantProps<
  typeof quantityInputControlStyles
> & {
  quantity: number;
  onIncrementClick: MouseEventHandler<HTMLButtonElement>;
  onDecrementClick: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  incrementDisabled?: boolean;
  decrementDisabled?: boolean;
};

export const QuantityInputControl = ({
  quantity,
  onIncrementClick,
  onDecrementClick,
  variant,
  size,
  className,
  incrementDisabled,
  decrementDisabled
}: QuantityInputControlProps) => {
  return (
    <div
      className={cn(quantityInputControlStyles({ variant, size }), className)}
    >
      <button
        type="button"
        onClick={onDecrementClick}
        className={quantityInputControlButtonStyles({
          variant,
          disabled: Boolean(decrementDisabled)
        })}
        disabled={decrementDisabled}
      >
        <FontAwesomeIcon icon={faMinus} />
      </button>
      <span className="flex-1">{quantity}</span>
      <button
        type="button"
        onClick={onIncrementClick}
        className={quantityInputControlButtonStyles({
          variant,
          disabled: Boolean(incrementDisabled)
        })}
        disabled={incrementDisabled}
      >
        <FontAwesomeIcon icon={incrementDisabled ? faBan : faPlus} />
      </button>
    </div>
  );
};
